import { Store, SerializedData } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { CampaignProductType, CampaignByIdQuery, UserLocationInput } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { FAILED_CAMPAIGN_FETCH } from "../config/systemEvents";

export class DealsStore extends Store {
  public bexApiService: BexApiService;
  public referrerId: string | null;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
    this.referrerId = null;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public mapCampaignProductTypes(productTypes: string[]): CampaignProductType[] | [] {
    return productTypes?.map((product: string) => {
      return CampaignProductType[product];
    });
  }

  public mapUserLocationInput(userLatitude?: number, userLongitude?: number): UserLocationInput | null {
    if (userLatitude && userLatitude !== null && userLongitude && userLongitude !== null) {
      return {
        userLatitude,
        userLongitude,
      };
    }

    return null;
  }

  public async fetchCampaignDeals(
    contextStore: ExtendedContextStore,
    campaignIds: string[],
    enableTripAttach: boolean,
    userLatitude?: number,
    userLongitude?: number,
    displayPropertyCount?: boolean,
    pageName?: string
  ): Promise<any> {
    const variables: CampaignByIdQuery.Variables = {
      campaignIds,
      enableTripAttach,
      context: getBexApiContext(contextStore),
      userLocation: this.mapUserLocationInput(userLatitude, userLongitude),
      displayPropertyCount,
      referrer: this.referrerId,
    };
    let campaign;
    try {
      const query = await this.bexApiService.fetchCampaignByIdQuery(variables);
      campaign = query.data.campaignRecommendations?.campaigns[0];
    } catch (err) {
      this.logger.logEvent(FAILED_CAMPAIGN_FETCH, "Unexpected error when fetching deals campaign offers", err);
    }

    return campaign;
  }
}
